import(/* webpackMode: "eager" */ "/codebuild/output/src2934355194/src/faunaexplore-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2934355194/src/faunaexplore-frontend/node_modules/next/dist/client/link.js");
